import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";

const PROMO_IMAGE = "https://customer-assets.emergentagent.com/job_af70e0d8-2a27-4431-96d1-1c57842c8dea/artifacts/y334710k_%233.png";
const DISMISS_KEY = "clearpath_promo_dismissed";
const DELAY_MS = 4000;

export default function PromoModal() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Session-based: uses sessionStorage so it resets when browser/tab closes
    if (sessionStorage.getItem(DISMISS_KEY)) return;
    const timer = setTimeout(() => setShow(true), DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const close = () => {
    setShow(false);
    sessionStorage.setItem(DISMISS_KEY, "1");
  };

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      data-testid="promo-modal-backdrop"
      onClick={close}
    >
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />

      <div
        className="relative w-full max-w-md bg-white rounded-2xl overflow-hidden shadow-2xl animate-in fade-in zoom-in-95 duration-300"
        onClick={(e) => e.stopPropagation()}
        data-testid="promo-modal"
      >
        <button
          onClick={close}
          className="absolute top-3 right-3 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/90 hover:bg-white text-slate-600 hover:text-slate-900 shadow transition-colors"
          data-testid="promo-modal-close"
        >
          <X className="w-4 h-4" />
        </button>

        <Link to="/shop?category=Infectious+Disease&featured=gcfc-525ska-25t" onClick={close} data-testid="promo-modal-image-link">
          <img
            src={PROMO_IMAGE}
            alt="Special Offer - Healgen COVID / Flu A&B POC Test Kits $4.99 per test"
            className="w-full h-auto"
            data-testid="promo-modal-image"
          />
        </Link>
      </div>
    </div>
  );
}
